
import React from 'react';

const Footer = () => {
    return (
        <div>
            {/* Footer content */}
        </div>
    );
};

export default Footer;
